export default function resolveStaticUrl(url: string) {
  return `${window.settings.STATIC_URL}${url}`;
}
